<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
    },
    // methods: {
    //   //App.vue
    //   _isMobile() {
    //     let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //     return flag;
    //   }
    // },
    // mounted() {
    //   if (this._isMobile()) {
    //     this.$router.replace('/login');
    //   } else {
    //     this.$router.replace('/loginMobile');
    //   }
    // },
  }
</script>

<style scoped>
 
</style>